export const E_INVOICING_SUPPORT_LINK =
  'https://help.shine.fr/shine-facture/fr/articles/13390711-comprendre-la-reforme-de-la-e-facturation'
